module.exports = __webpack_public_path__ + "static/media/hw-evaluated.6c6e048a.svg";